import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { ThemeProvider } from "@/lib/theme";
import { AppShell } from "@/components/atas/AppShell";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import HtePage from "@/pages/HtePage";
import ProgramPage from "@/pages/ProgramPage";
import AdminTipsPage from "@/pages/AdminTipsPage";
import PesertaPage from "@/pages/PesertaPage";
import KajianListPage from "@/pages/KajianListPage";
import KajianPage from "@/pages/KajianPage";
import AdminKerangkaPage from "@/pages/AdminKerangkaPage";
import { MeProvider } from "@/lib/me";
import AkaunPage from "@/pages/AkaunPage";
import MockPayPage from "@/pages/MockPayPage";
import AdminBillingPage from "@/pages/AdminBillingPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

const Protected = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

const AuthPage = ({ children }) => (
  <div className="flex items-center justify-center px-4 py-12 min-h-[70vh]">{children}</div>
);

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ClerkAuthProvider>
          <MeProvider>
          <AppShell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/peserta/:kod" element={<PesertaPage />} />
              <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
              <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
              <Route path="/hte" element={<Protected><HtePage /></Protected>} />
              <Route path="/program" element={<Protected><ProgramPage /></Protected>} />
              <Route path="/kajian" element={<Protected><KajianListPage /></Protected>} />
              <Route path="/kajian/:id" element={<Protected><KajianPage /></Protected>} />
              <Route path="/admin" element={<Protected><AdminDashboardPage /></Protected>} />
              <Route path="/admin/kerangka" element={<Protected><AdminKerangkaPage /></Protected>} />
              <Route path="/admin/tips" element={<Protected><AdminTipsPage /></Protected>} />
              <Route path="/admin/bil" element={<Protected><AdminBillingPage /></Protected>} />
              <Route path="/akaun" element={<Protected><AkaunPage /></Protected>} />
              <Route path="/bayar-ujian/:id" element={<Protected><MockPayPage /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AppShell>
          </MeProvider>
          <Toaster position="top-center" />
        </ClerkAuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
